import { Button } from 'antd'

type ButtonFixedProps = {
  onClickButton?: () => void
  style?: any
  text?: string
  icon?: any
  loading?: boolean
  disable?: boolean
}

const ButtonFixed = ({
  text,
  onClickButton,
  icon,
  style,
  disable,
}: ButtonFixedProps) => {
  return (
    <Button
      style={style}
      onClick={() => {
        onClickButton && onClickButton()
      }}
      disabled={disable ? disable : false}
    >
      {icon}
      {text}
    </Button>
  )
}

export default ButtonFixed
